import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GatewaysShellComponent } from './containers/gateways-shell/gateways-shell.component';

const routes: Routes = [
  {
    path: '',
    component: GatewaysShellComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GatewaysRoutingModule {}
